import moment from 'moment';

import { ISelectedFilterBody } from '../models/TableFilterModels';

export const requestParseTime = (filters: ISelectedFilterBody[] | []) => {
	if (!filters?.length) {
		return filters;
	}

	const dateTimeISOFormat = 'YYYY-MM-DDTHH:mm:ss';
	const dateTimeRequestFormat = 'YYYY-MM-DD HH:mm:ss';

	return [...filters].map(el => {
		if (el.value_type === 'datetime') {
			return {
				...el,
				values: moment(`${el.values}:00`, dateTimeISOFormat)
					.utc()
					.format(dateTimeRequestFormat),
			};
		}
		return el;
	});
};
